import MatkaBet from './MatkaBet';

export default MatkaBet;